// Dish Tech React
import {getStore} from '@dishtech-react/redux';

// Configs
import {formConfig} from '../../config/form-config';
import {serviceConfig} from '../../config/service-config';
import {resultsReducer as results} from './reducers/results-reducer';
import {resultsMiddleware} from './middlewares/results-middleware';

const [store, history] = getStore({formConfig, serviceConfig}, {results}, [resultsMiddleware]);

export {history};
export default store;
